module.exports = "https://static.wagwalking.com/_next/static/images/featured-providers-desktop-a83f766ee0acc578fdf92cf955b834bd.png";